import NodeCache from 'node-cache';

const cache = new NodeCache();

export default cache;
